import {
  Divider,
  Flex,
  Stack,
  TextButton,
  Typography,
} from "@strapi/design-system";
import { Button, Form, Input, message } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { setUserInfo } from "../redux/action/app";
import { getProfile, login } from "../util/API";

const Login = ({ lng = "vi" }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const location = useLocation();
  const [isSignup, setIsSignUp] = useState(false);

  useEffect(() => {
    onLoggedin();
    if (location?.state?.signup) {
      setIsSignUp(true)
    }
  }, []);

  useEffect(() => {
    if (lng) {
      i18n.changeLanguage(lng);
    }
  }, [lng]);

  const onLoggedin = () => {
    const token = localStorage.getItem("token");
    if (token) {
      if (lng === "en") navigate(`/nomination/profile`);
      else navigate(`/nomination/ho-so`);
    }
  };

  const handleSubmit = async (e) => {
    try {
      const response = await login({
        identifier: email,
        password: password,
      });

      if (response.status === 200) {
        const { user, jwt } = response.data;
        localStorage.setItem("token", jwt);
        localStorage.setItem("user", JSON.stringify(user));
        await getUserInfo();
        if (lng === "en") navigate(`/nomination/profile`);
        else navigate(`/nomination/ho-so`);
      }
    } catch (error) {}
  };

  const getUserInfo = async () => {
    try {
      const response = await getProfile();
      dispatch(setUserInfo(response.data));
    } catch (error) {
      console.error(error);
      // TODO: Handle error while fetching profile
    }
  };

  const handleSignUpLink = () => {
    if (i18n.language === "en") navigate(`/nomination/sign-up`);
    else navigate(`/nomination/dang-ky`);
  };

  const handleForgotPassword = () => {
    if (lng === "en") navigate("/nomination/forgot-password");
    else navigate("/nomination/quen-mat-khau");
  };

  return (
    <div>
      {isSignup ? <div style={{
        position: "absolute",
        width: "100%",
        left: 0,
        backgroundColor: "rgb(208, 43, 32)",
        textAlign: "center",
        padding: "7px 10px"
      }}>
        <p style={{color: "white"}}>{t("str_is_signup")}</p>
      </div> : <></> }
      {contextHolder}
      <div className="login-form-wrapper">
        <div className="login-form-container p-40">
          <Flex
            paddingBottom={4}
            paddingTop={4}
            justifyContent="center"
            direction="column"
          >
            <Typography variant="alpha" style={{ textAlign: "center" }}>
              {t("str_login")}
            </Typography>
            <span className="subnotes" style={{ marginTop: "10px" }}>
              {t("str_login_sub_text")}
            </span>
          </Flex>

          <Divider />

          <Form
            layout="vertical"
            name="basic"
            style={{
              maxWidth: 600,
            }}
            onFinish={handleSubmit}
            autoComplete="off"
          >
            <Form.Item
              label="Email"
              name="username"
              onChange={(e) => setEmail(e.target.value)}
              rules={[
                {
                  required: true,
                  message: t("str_required_email"),
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label={t("str_password")}
              name="password"
              onChange={(e) => setPassword(e.target.value)}
              rules={[
                {
                  required: true,
                  message: t("str_required_password"),
                },
              ]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item>
              <Button htmlType="submit" type="primary" className="btnSave">
                <span style={{ textTransform: "uppercase" }}>
                  {t("str_login")}
                </span>
              </Button>
            </Form.Item>
          </Form>

          <Stack spacing={4} horizontal>
            <TextButton onClick={handleForgotPassword}>
              {t("str_forget_password")}
            </TextButton>
            <TextButton onClick={handleSignUpLink}>
              {t("str_register")}
            </TextButton>
          </Stack>
        </div>
      </div>
    </div>
  );
};

export default Login;
